'use client';

import Box from '@enlighten/design-system/dist/Box';
import Stack from '@enlighten/design-system/dist/Stack';
import Typography from '@enlighten/design-system/dist/Typography';
import React from 'react';

import ChevronIcon from '@/assets/images/commons/chevron.svg';

import DetailToggleButton from './DetailToggleButton';

const PANEL_ID = 'solar-support-allocation-notice';
const TITLE = '할당대상업체란';

const LINES: { text: string; isBold?: boolean }[] = [
	{ text: '기후에너지환경부장관이 할당계획에서 정한 부문·업종의 온실가스 배출업체 중에서 지정·고시하는 업체입니다.' },
	{ text: '지정 기준은 최근 3년간 온실가스 배출량의 연평균 총량이 125,000tCO₂-eq 이상인 업체, 또는 25,000tCO₂-eq 이상인 사업장을 하나 이상 보유한 업체입니다.', isBold: true },
	{ text: '기준에 미달하더라도 신청을 통해 자발적 참여업체로 지정받을 수 있습니다.' },
	{ text: '지정·고시는 매 계획기간 시작 5개월 전까지 이루어지며, 명단은 관보와 기후에너지환경부 공표 자료에서 확인할 수 있습니다.' },
	{ text: '(「온실가스 배출권의 할당 및 거래에 관한 법률」 제8조, 같은 법 시행령 제9조)' },
];

const AllocationNotice = () => {
	const [isOpen, setIsOpen] = React.useState(false);

	const handleDetailToggle = () => setIsOpen((previous) => !previous);

	return (
		<Stack
			alignItems="center"
			gap={{ xs: '10px', md: '20px' }}
			marginTop="40px"
			padding={{ xs: '24px', md: '40px' }}
			bgcolor={{ xs: '#FFFFFF', md: '#F9F6FF' }}
			border={{ xs: '1px solid #EBEDEF', md: 'none' }}
			borderRadius={{ xs: '20px', md: '16px' }}
			boxShadow={{ md: '0px 4px 28px 0px rgba(0, 0, 0, 0.1)' }}
		>
			<Stack
				component="button"
				type="button"
				aria-expanded={isOpen}
				aria-controls={PANEL_ID}
				onClick={handleDetailToggle}
				display={{ xs: 'none', md: 'flex' }}
				direction="row"
				alignItems="center"
				justifyContent="space-between"
				width="100%"
				padding={0}
				sx={{ appearance: 'none', border: 'none', background: 'none', cursor: 'pointer' }}
			>
				<Typography fontSize="28px" fontWeight={700} color="#6400FF">
					{TITLE}
				</Typography>
				<Stack direction="row" alignItems="center" gap="12px">
					<Typography fontSize="22px" fontWeight={500} color="#666666">
						자세히 보기
					</Typography>
					<Box display="flex" color="#666666" sx={{ transform: isOpen ? 'rotate(-90deg)' : 'rotate(90deg)' }}>
						<ChevronIcon width={40} height={40} />
					</Box>
				</Stack>
			</Stack>

			<Typography display={{ md: 'none' }} fontSize="18px" fontWeight={700} color="#6400FF" textAlign="center">
				{TITLE}
			</Typography>

			{/* aria-controls 가 항상 실제 노드를 가리키도록 접힌 상태에서도 마운트 유지 */}
			<Stack id={PANEL_ID} display={isOpen ? 'flex' : 'none'} width="100%">
				{LINES.map(({ text, isBold }) => (
					<Typography
						key={text}
						fontSize={{ xs: '18px', md: '20px' }}
						fontWeight={isBold ? 700 : 400}
						lineHeight={{ xs: '28px' }}
						textAlign={{ xs: 'center', md: 'left' }}
						sx={{ wordBreak: 'keep-all' }}
					>
						{text}
					</Typography>
				))}
			</Stack>

			<Box display={{ md: 'none' }} width="100%" paddingX="31px">
				<DetailToggleButton isOpen={isOpen} panelId={PANEL_ID} onClick={handleDetailToggle} />
			</Box>
		</Stack>
	);
};

export default AllocationNotice;
